import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { LayoutTriggers } from 'defs/layout';
import i18n from 'helper/i18n';
import appConfig from 'helper/mapBackendConfig';
import noop from 'helper/noop';

import Icon from 'components/atoms/Icon';
import Link from 'components/atoms/Link';
import { isNativePlatform } from 'components/helper/Platform';
import withLayout from 'components/hoc/withLayout';
// FIXME:F2TS type import from flow
import { WithLayoutPropsType } from 'components/hoc/withLayout';
import LoginButton from 'containers/molecules/LoginButton';

type OffCanvasLink = {
	icon: string;
	text: string;
	id: string;
	href: string;
	selected?: boolean;
	additions: Array<Function>;
};

export type OffCanvasProps = {
	onClose: () => void;
	isOpen: boolean;
	links: OffCanvasLink[];
	userData?: {
		firstName: string;
		lastName: string;
	};
	activeViewId?: string;
	router?: Object;
	todayDayOfMonth: string;
	linksSignature: string; // for shallow compare
	oneTrustEnabled: boolean;
} & WithLayoutPropsType;

export class OffCanvas extends React.Component<OffCanvasProps> {
	public static displayName = 'OffCanvas';

	public static defaultProps = {
		onClose: noop,
		onBack: noop,
		links: [],
		additions: [],
		isOpen: false,
		activeViewId: '',
	};

	public componentDidUpdate(prevProps: OffCanvasProps) {
		const { isOpen, doLockBody, doUnlockBody } = prevProps;

		if (!isOpen && this.props.isOpen) {
			doLockBody(LayoutTriggers.OffCanvas);
		}

		if (isOpen && !this.props.isOpen) {
			doUnlockBody(LayoutTriggers.OffCanvas);
		}
	}

	public handleClose = () => {
		setTimeout(this.props.onClose, 0);
	};

	public renderItem(item: OffCanvasLink, index: number): any {
		const { id, icon, text, href, additions, selected } = item;
		const { todayDayOfMonth } = this.props;

		const isToday: boolean = id === 'today' || id === 'today-selected';

		if (href && text) {
			return (
				<li
					key={index}
					className={`m-off-canvas__item${selected ? ' state-m-off-canvas__item--selected' : ''}`}
				>
					<RouterLink className="m-off-canvas__item-box" to={href} onClick={this.handleClose}>
						<div className={`m-off-canvas__item-icon m-off-canvas__item-icon--${icon}`}>
							{additions
								? additions.map((Addition: any, addIndex: number) => <Addition key={addIndex} />)
								: null}
							{icon && <Icon iconName={icon} />}
							{isToday && <span className="m-off-canvas__item-day">{todayDayOfMonth}</span>}
						</div>
						<span className="m-off-canvas__item-label">{text}</span>
					</RouterLink>
				</li>
			);
		}
	}

	public renderCookieConsent() {
		const { oneTrustEnabled } = this.props; // TODO: set by config
		const isNative = isNativePlatform();

		if (oneTrustEnabled && isNative) {
			return (
				<div className="m-off-canvas__link">
					<a className="a-nexus a-nexus--base a-nexus--text" role="button">
						<span className="a-nexus__text ot-sdk-show-settings">&nbsp;</span>
					</a>
				</div>
			);
		}
	}

	public render() {
		const { isOpen, links, userData } = this.props;

		return (
			<nav className={`m-off-canvas${isOpen ? ' state-m-off-canvas--open' : ''}`}>
				<div className="m-off-canvas__wrap" onClick={this.handleClose}>
					<span className="m-off-canvas__close" onClick={this.handleClose}>
						<Icon iconName="close" />
					</span>
				</div>

				<div className="m-off-canvas__content">
					{links && links.length > 0 && (
						<ul className="m-off-canvas__list">{links.map(this.renderItem.bind(this))}</ul>
					)}

					<div className="m-off-canvas__link">
						<Link
							modifier="base"
							title={i18n('react.impulsCoach.components.offCanvas.backLink.title')}
							iconLeft=""
							iconRight=""
							externalHref={`${appConfig.env.migrosImpulsURL}`}
						/>
					</div>

					{this.renderCookieConsent()}

					<div className="m-off-canvas__user">
						{userData && (
							<span className="m-off-canvas__user-name">
								{`${userData.firstName} ${userData.lastName}`}
							</span>
						)}
						<div className="m-off-canvas__login m-off-canvas__login-button">
							<LoginButton setupLoginFlow showLoginButton />
						</div>
					</div>
				</div>
			</nav>
		);
	}
}

export default withLayout(OffCanvas);
